<div *ngIf="infoText" class="ds-grid mb-4">
  <div class="row">
    <div *ngIf="!g2Product.review_count" class="col-12 mb-5 ds-body--l text-center mx-auto">
      {{'productReview.beTheFirstToReview' | cxTranslate}}
    </div>
    <div *ngIf="g2Product.review_count" [class.ds-body--l]="pageCount === 0" [class.mt-6]="pageCount !== 0"
         class="col-12 mb-5 text-center">
      {{infoText}}
    </div>
    <div class="col-12 text-center">
      <dcp-write-review [btnLabel]="btnText" [g2Product]="g2Product"></dcp-write-review>
    </div>
  </div>
</div>
